import React from 'react'

const HamburgerIcon = () => {
  return (
    <svg>
        <g fill="currentColor" fillRule="evenodd">
            <path d="M0 0h16v3H0zM0 6h16v3H0zM0 12h16v3H0z"/>
        </g>
    </svg>
  )
}

export default HamburgerIcon